import client from "../client";

interface Request {
  hashkey?: string;
}

export interface CliamCommissionRankingResponse {
  message?: string;
}

export default function API(
  request: Request
): Promise<CliamCommissionRankingResponse> {
  return client
    .post(`commission/cliam_commission_ranking`, request)
    .then((response) => response.data);
}
